<div>
    <select class="form-control mobile-hide" [(ngModel)]="selectedEvent">
        <option [value]="item.id" *ngFor="let item of eventList;trackBy:trackByIndex;">{{item.name}}</option>
    </select>

    <div class="openBetsTabs">
        <tabset>
            <tab heading="Matched" id="tab1">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <td>Selname</td>
                                <td>Odds</td>
                                <td>Stake</td>
                                <td>Date/Time</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [ngClass]="item.bet_type == 1 ? 'greenbg' : 'redbg'"
                                *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>{{item.runner_name}} {{item.market_type}} </td>
                                <td>{{item.average_rate_matched | number}}</td>
                                <td>{{item.stake_matched | number}}</td>
                                <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date : 'dd/MM/YYYY hh:mm:ss a'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
            <tab heading="UnMatched">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <td>Selname</td>
                                <td>Odds</td>
                                <td>Stake</td>
                                <td>Date/Time</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [ngClass]="item.bet_type == 1 ? 'greenbg' : 'redbg'"
                                *ngFor="let item of data.unMatched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>{{item.runner_name}} {{item.market_type}} </td>
                                <td>{{item.rate | number}}</td>
                                <td>{{item.stake_remaining | number}}</td>
                                <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date : 'dd/MM/YYYY hh:mm:ss a'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
            <tab heading="Fancy">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <td>Selname</td>
                                <td>Odds</td>
                                <td>Stake</td>
                                <td>Date/Time</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [ngClass]="item.bet_type == 1 ? 'greenbg' : 'redbg'"
                                *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>{{item.runner_name}} {{item.market_type}} </td>
                                <td>{{item.price != 100 ? (item.rate | number)+'/'+(item.price | number) :
                                    item.average_rate_matched | number}}</td>
                                <td>{{item.stake_matched | number}}</td>
                                <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date : 'dd/MM/YYYY hh:mm:ss a'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
        </tabset>
    </div>
    <!-- <div class="openBetsTabs">
        <tabset>
            <tab heading="Matched" id="tab1">
                <div class="table-resposive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Back (Bet For)</th>
                                <th>odds</th>
                                <th>stake</th>
                                <th>profit</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataLength.matchedB > 0">
                            <tr class="back" [ngClass]="{'dis-none' : item.bet_type == 0}"
                                *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>
                                    <div class="st-sa">
                                        <span class="slip-type">Back</span>
                                        <span class="short-amount">{{item.runner_name}}
                                            <small>{{item.market_type_id}}</small> </span>
                                    </div>
                                </td>
                                <td>{{item.average_rate_matched}}</td>
                                <td>{{item.stake_matched}}</td>
                                <td>{{item.win}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataLength.matchedB == 0">
                            <tr>
                                <td colspan="4"> No records found</td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th>lay (Bet against)</th>
                                <th>odds</th>
                                <th>stake</th>
                                <th>profit</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataLength.matchedL > 0">
                            <tr class="lay" [ngClass]="{'dis-none' : item.bet_type == 1}"
                                *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>
                                    <div class="st-sa">
                                        <span class="slip-type">lay</span>
                                        <span class="short-amount">{{item.runner_name}}
                                            <small>{{item.market_type_id}}</small> </span>
                                    </div>
                                </td>
                                <td>{{item.average_rate_matched}}</td>
                                <td>{{item.stake_matched}}</td>
                                <td>{{item.lose}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataLength.matchedL == 0">
                            <tr>
                                <td colspan="4"> No records found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
            <tab heading="UnMatched">
                <div class="table-resposive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Back (Bet For)</th>
                                <th>odds</th>
                                <th>stake</th>
                                <th>profit</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataLength.unMatchedB > 0">
                            <tr class="back" [ngClass]="{'dis-none' : item.bet_type == 0}"
                                *ngFor="let item of data.unMatched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>
                                    <div class="st-sa">
                                        <span class="slip-type">Back</span>
                                        <span class="short-amount">{{item.runner_name}}
                                            <small>{{item.market_type_id}}</small> </span>
                                    </div>
                                </td>
                                <td>{{item.average_rate_matched}}</td>
                                <td>{{item.stake_matched}}</td>
                                <td>{{item.win}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataLength.unMatchedB == 0">
                            <tr>
                                <td colspan="4"> No records found</td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th>lay (Bet against)</th>
                                <th>odds</th>
                                <th>stake</th>
                                <th>profit</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataLength.unMatchedL > 0">
                            <tr class="lay" [ngClass]="{'dis-none' : item.bet_type == 1}"
                                *ngFor="let item of data.unMatched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>
                                    <div class="st-sa">
                                        <span class="slip-type">lay</span>
                                        <span class="short-amount">{{item.runner_name}}
                                            <small>{{item.market_type_id}}</small> </span>
                                    </div>
                                </td>
                                <td>{{item.average_rate_matched}}</td>
                                <td>{{item.stake_matched}}</td>
                                <td>{{item.lose}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataLength.unMatchedL == 0">
                            <tr>
                                <td colspan="4"> No records found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
            <tab heading="Fancy">
                <div class="table-resposive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Back (Bet For)</th>
                                <th>odds</th>
                                <th>stake</th>
                                <th>profit</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataLength.fancyB > 0">
                            <tr class="back" [ngClass]="{'dis-none' : item.bet_type == 0}"
                                *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>
                                    <div class="st-sa">
                                        <span class="slip-type">Back</span>
                                        <span class="short-amount">{{item.runner_name}}
                                            <small>{{item.market_type_id}}</small> </span>
                                    </div>
                                </td>
                                <td>{{item.average_rate_matched}}{{item.price == 100.00 ? "":"/"+item.price}}</td>
                                <td>{{item.stake_matched}}</td>
                                <td>{{item.win}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataLength.fancyB == 0">
                            <tr>
                                <td colspan="4"> No records found</td>
                            </tr>
                        </tbody>
                        <thead>
                            <tr>
                                <th>lay (Bet against)</th>
                                <th>odds</th>
                                <th>stake</th>
                                <th>profit</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="dataLength.fancyL > 0">
                            <tr class="lay" [ngClass]="{'dis-none' : item.bet_type == 1}"
                                *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>
                                    <div class="st-sa">
                                        <span class="slip-type">lay</span>
                                        <span class="short-amount">{{item.runner_name}}
                                            <small>{{item.market_type_id}}</small> </span>
                                    </div>
                                </td>
                                <td>{{item.average_rate_matched}}</td>
                                <td>{{item.stake_matched}}</td>
                                <td>{{item.lose}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="dataLength.fancyL == 0">
                            <tr>
                                <td colspan="4"> No records found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </tab>
        </tabset>
    </div> -->
</div>